export default {"src":"/_next/static/image/public/images/ic_off_bg.7e2813b9c77c9b130ea209077ebea902.svg","height":24,"width":74};